import { faChevronDown, faChevronUp } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Chip, Collapse, darken, Divider, ListItemButton, ListItemText, Table, TableBody, TableCell, TableHead, TableRow, useTheme } from "@mui/material";
import { DateTime } from "luxon";
import { FC, useContext, useState } from "react";
import { LotChange } from "../api/dtos";
import LotChangesContext from "../contexts/LotChangesContext";

interface ILotHistoryItemProps {
    lotChange: LotChange
}

export const LotHistoryItem: FC<ILotHistoryItemProps> = ({lotChange}) => {
    const [expanded, setExpanded] = useState(false)

    return (
        <>
            <ListItemButton
                onClick={() => setExpanded(currentState => !currentState)}
            >
                <ListItemText 
                    primary={`Change By ${lotChange.changedBy}`} 
                />
                <Chip 
                    color={"primary"} 
                    label={DateTime.fromISO(lotChange.changeTime!).toFormat("dd/MM/yyyy hh:mm:ss").toString()}
                />
                <FontAwesomeIcon icon={expanded ? faChevronUp : faChevronDown} fixedWidth />
            </ListItemButton>
            <Collapse in={expanded}>
                <Box>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    Field
                                </TableCell>
                                <TableCell>
                                    Old Value
                                </TableCell>
                                <TableCell>
                                    New Value
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                lotChange.details?.map(lotChangeDetail => {
                                    return (
                                        <TableRow>
                                            <TableCell>
                                                {lotChangeDetail.field}
                                            </TableCell>
                                            <TableCell>
                                                {lotChangeDetail.oldValue}
                                            </TableCell>
                                            <TableCell>
                                                {lotChangeDetail.newValue}
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                            }
                        </TableBody>
                    </Table>
                </Box>
            </Collapse>
        </>
    );
};

interface ILotHistoryProps {
    lotId: number
}

export const LotHistory: FC<ILotHistoryProps> = () => {
    const theme = useTheme();

    const [expanded, setExpanded] = useState(false);

    const {data: lotChanges} = useContext(LotChangesContext);

    return (
        <>
            <ListItemButton
                sx={{
                    marginTop: theme.spacing(2),
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.common.white,
                    ":hover": {
                        backgroundColor: theme.palette.primary.main
                    }
                }}
                onClick={() => setExpanded(currentState => !currentState)}
            >
                <ListItemText primary="Lot History" />
                <Chip 
                    sx={{
                        backgroundColor: darken(theme.palette.secondary.main, 0.2),
                        color: theme.palette.common.white,
                        marginRight: theme.spacing(1)
                    }}
                    size="small"
                    label={`${lotChanges?.length} Changes`} 
                />
                <FontAwesomeIcon opacity={0.5} icon={expanded ? faChevronUp : faChevronDown} fixedWidth />
            </ListItemButton>
            <Collapse in={expanded}>
                <Box>
                    {
                        lotChanges?.map(lotChange => 
                            <>
                                <LotHistoryItem lotChange={lotChange} />
                                <Divider />
                            </>
                            
                        )
                    }
                </Box>
            </Collapse>
        </>
    );
}